import { createFileRoute } from '@tanstack/react-router'
import Gmail from '@/pages/apps/gmail'

export const Route = createFileRoute('/_authenticated/apps/gmail')({
  component: Gmail,
})
